var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38138 0.256148C6.70173 -0.0642101 7.20836 -0.0839801 7.55204 0.196332L7.61869 0.256148L13.7437 6.38127C14.0854 6.72298 14.0854 7.27688 13.7437 7.61859L7.61869 13.7437C7.27698 14.0854 6.72309 14.0854 6.38138 13.7437C6.03967 13.402 6.03967 12.8481 6.38138 12.5064L11.0127 7.87495H0.875004C0.391753 7.87495 0 7.48319 0 6.99993C0 6.51667 0.391753 6.12491 0.875004 6.12491H11.0127L6.38138 1.49348L6.32156 1.42682C6.04125 1.08314 6.06102 0.576505 6.38138 0.256148Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRightArrow);
export default __webpack_public_path__ + "static/media/blueRightArrow.6a4c2915f28f4f9b3d32f933f4ca8790.svg";
export { ForwardRef as ReactComponent };